import { lazy } from "react";

export const Dashboard = lazy(() => import("pages/Dashboard"));

export const SignIn = lazy(() => import("pages/SignIn"));

export const ForgotPassword = lazy(() => import("pages/ForgotPassword"));

export const NewPassword = lazy(() => import("pages/NewPassword"));

export const Budget = lazy(() => import("pages/Budget"));

export const BudgetRegister = lazy(() => import("pages/Budget/register"));

export const SystemSetup = lazy(() => import("pages/SystemSetup"));

export const Company = lazy(() => import("pages/Company"));
